import { Board, List } from '../model/types/tasksInformationSchema';

// type DataStructure = {
//     [key: string]: string[]; // Тип для словаря с массивами идентификаторов
// };

export function findKeyTabById(data: List | Board, searchId: string): string | null {
    for (const key in data) {
        if (data[key as keyof typeof data].includes(searchId)) {
            return key;
        }
    }
    return null;
}
